import SettingsHome from './settings/SettingsHome';

export default SettingsHome;
